/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import settings from '@nobia/zeus-components/lib/settings'
import PropTypes from 'prop-types'
import React from 'react'

export const getIcon = (name) => {
  let NamedIcon = null
  try {
    NamedIcon = require(`../../assets/icons/${settings.brand}/${name}.svg`)
    // eslint-disable-next-line no-empty
  } catch (error) {}
  if (!NamedIcon || !NamedIcon.ReactComponent) {
    try {
      NamedIcon = require(`../../assets/icons/${name}.svg`)
      // eslint-disable-next-line no-empty
    } catch (error) {}
  }

  if (!NamedIcon || !NamedIcon.ReactComponent) {
    throw new Error(`Could not find icon ${name}`)
  }
  return NamedIcon
}

const Icon = ({ name, ...props }) => {
  const NamedIcon = getIcon(name)

  return <NamedIcon.ReactComponent {...props} />
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Icon
